import React, { createContext, useCallback, useContext, useState, useEffect, useRef } from "react";
import NotificationDommus from "../helpers/NotificationsHelper";
import { celularMask } from "../components/InputTextMask";
import { Device } from '@twilio/voice-sdk';
import caAPI from "../services/caAPI";
import Swal from "sweetalert2";
import { AtendimentoContext } from "./AtendimentoContext";
import { useStopwatch } from 'react-timer-hook';
import { trackPromise } from "react-promise-tracker";
import phoneRing from "../assets/Audio/modern-phone.mp3"
import { errorToast, infoToast } from "../components/DommusToast";
import { WebSocketContext } from "./WebSocketContext";

export const VoipContext = createContext({});

export function VoipProvider({ children }) {
  const [inCallStatus, setInCallStatus] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [connection, setConnection] = useState(false);
  const [chamadasPerdidas, setChamadasPerdidas] = useState([]);
  const [triggerCloseModalIncoming, setTriggerCloseModalIncoming] = useState(null);
  const [microfonePermitido, setMicrofonePermitido] = useState(null)
  const [atendimentoInCall, setAtendimentoInCall] = useState(null);
  const { atendimentoAtivo, setAtendimentoAtivo, finalizarAtendimento } = useContext(AtendimentoContext);
  const { channel } = useContext(WebSocketContext)
  const twilioCallClient = useRef(null);
  const twilioRespondeClient = useRef(null)
  // Identificação da oferta recebida, guardada entre o `receiveCall` (quando o telefone toca)
  // e o `answerCall` (quando o atendente aceita): o aceite precisa confirmar o atendimento no
  // backend ANTES de conectar o áudio, e é aqui que ele acha a tentativa a reivindicar.
  const ofertaRecebida = useRef(null)
  const [openModalAdicionarMarcadoresVoip, setOpenModalAdicionarMarcadoresVoip] = useState(false);
  const {
    seconds,
    minutes,
    isRunning,
    start,
    pause,
    reset,
  } = useStopwatch({ autoStart: false });

  const adicionaChamadaPerdida = (chamada = {}) => {
    setChamadasPerdidas((valorAnterior) => {
      return [...valorAnterior, chamada]
    })
    NotificationDommus.showNotification(`Você tem uma ligação perdida de ${celularMask(chamada.contato)}`, 'Ligação Perdida')
  }

  const registrarClient = async (client) => {
    await client.register();
  }

  const handleCloseModalIncoming = () => {
    const trigger = Math.random();
    return setTriggerCloseModalIncoming(trigger);
  };

  /**
   * @param identificacaoTentativa {id_conteudo_atendimento, call_sid, numero_tentativa} da
   * oferta aceita, ou null nos fluxos sem ciclo de tentativas (transferência, ligação ativa).
   */
  const clienteTwilioRespondeFactory = useCallback((tokenTwilio, opcoes = {}, idAtendimentoRecebido = null, identificacaoTentativa = null) => {
    const device = new Device(tokenTwilio, opcoes);
    device.on('incoming', (call) => {
      call.on('cancel', () => {
        registrarContador();
        handleCloseModalIncoming();
        setInCallStatus(false);
        setConnection(false);
        setIsMuted(false);
        if(call?.ignore) {
          call?.ignore()
        }
      });

      call.on('disconnect', () => {
        registrarContador()
        handleCloseModalIncoming();
        setInCallStatus(false);
        setConnection(false);
        setIsMuted(false);
        if(call?.ignore) {
          call?.ignore()
        }
      });

      // A conexão do áudio (`connection.accept()`) só acontece depois que `answerCall`
      // confirma o atendimento no backend. Aqui, quando o áudio enfim conecta, só refletimos
      // o estado local da UI — o `PUT /atender` já foi feito e aceito.
      call.on('accept', () => {
        setInCallStatus(true);
      });
      setConnection(call);
      start();
    });

    device.on('unregistered', () => {
      setConnection(null)
      handleCloseModalIncoming();
    })

    device.on('registered', () => {
      // if (idAtendimentoRecebido) {
      //   caAPI.atendimento
      //     .chamar(idAtendimentoRecebido)
      //     .then(
      //       (res) => console.log("Chamado")
      //     ).catch(
      //       (error) => handleLigacaoPerdida()
      //     );
      // }
    })

    device.on('error', (error, call) => {
      handleLigacaoPerdida();
    });

    device.audio.on('deviceChange', () => {
      if(solicitarPermissaoMicrofone() === false) {
        handleLigacaoPerdida()
      }
    });

    return device;
  }, [atendimentoAtivo, setAtendimentoAtivo]);

  const handleLigacaoPerdida = () => {
    if(twilioRespondeClient.current?.calls?.length) {
      const conexao = twilioRespondeClient.current.calls.shift();
      conexao.ignore()
      twilioRespondeClient.current.disconnectAll();
      twilioRespondeClient.current.destroy();
      setConnection(null);
      twilioRespondeClient.current = null;
    }

    if(twilioCallClient.current?.calls?.length) {
      const conexao = twilioCallClient.current.calls.shift();
      conexao.ignore()
      twilioCallClient.current.disconnectAll();
      twilioCallClient.current.destroy();
      setConnection(null);
      twilioCallClient.current = null;
    }

    handleCloseModalIncoming()
  }

  const handleLigacaoAtivaEncerrada = () => {
    let handlerDesconectar = ligacaoDesconectada;
    if (twilioCallClient && twilioCallClient.current) {
      if (connection) {
        let statusConexao = connection.status();
        if (statusConexao === 'open' || statusConexao === 'closed') {
          handlerDesconectar = ligacaoDesconectadaComContador;
        }
        connection.disconnect();
      }
      if(twilioCallClient.current?.calls?.length) {
        const conexao = twilioCallClient.current.calls.shift();
        conexao.ignore()
      }
      twilioCallClient.current?.disconnectAll();
      twilioCallClient.current?.destroy();
      setConnection(null);
      twilioCallClient.current = null;
      handlerDesconectar();
    }
     Swal.fire({
        titleText: "Ligação Encerrada",
        icon: 'warning',
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary mr-3',
        },
        buttonsStyling: false
      }).then(
        (result) => {
         handleFinalizarAtendimento();   
      })
  }

  const ligacaoDesconectada = () => {
    handleLigacaoAtivaEncerrada();
    setInCallStatus(false);
    setConnection(false);
    setIsMuted(false);
    setAtendimentoInCall(null);
  };

  const ligacaoDesconectadaComContador = () => {
    registrarContador();
    ligacaoDesconectada();
  };

  useEffect(()=>{
    if(!inCallStatus && atendimentoInCall){
      setAtendimentoInCall(null);
    }
  },[inCallStatus])

  //Para Ligação Iniciada
  const setupCallClient = async (tokenTwilio, atendimento = null) => {
    try {
      if (!atendimento && atendimentoAtivo) {
        atendimento = Object.assign({}, atendimentoAtivo);
      }

      if (atendimento) {
        if (!atendimentoAtivo) {
          setAtendimentoAtivo(Object.assign({}, atendimento));
        }
        const twilioDevice = new Device(tokenTwilio, getOpcoesClienteTwilio());
        twilioDevice.on('error', function (error) {
          handleLigacaoAtivaEncerrada();
        });
        twilioDevice.on('unregistered', () => {
          setConnection(null)
          handleLigacaoAtivaEncerrada();
        })
        twilioDevice.audio.on('deviceChange', () => {
          if(solicitarPermissaoMicrofone() === false) {
            handleLigacaoAtivaEncerrada();
          }
        })

        const dadosVoip = {
          id_atendimento: atendimento.id,
          id_cliente: caAPI.getLocalState('idCliente'),
          contato_externo: atendimento.contato_destino,
          contato_interno: atendimento.contato_origem,
          direcao: 'enviado'
        };
        twilioCallClient.current = twilioDevice;
        setInCallStatus(true);
        const call = await twilioDevice.connect({ params: dadosVoip });
        call.on('cancel', () => {
          handleLigacaoAtivaEncerrada()
        });

        call.on('error', (error) => {
          handleLigacaoAtivaEncerrada();
        });

        call.on('reject', (error) => {
          handleLigacaoAtivaEncerrada();
        });

        call.on('ignore', (error) => {
          handleLigacaoAtivaEncerrada();
        });

        call.on('disconnect', () => {
          ligacaoDesconectadaComContador();
        });

        call.on('accept', (call) => {
          caAPI.atendimento.voip.novoIniciarChamada(call.customParameters.get('id_atendimento'), call.parameters.CallSid).then(res => {
            const novoAtendimentoAtivo = Object.assign({}, atendimentoAtivo);
            if (!(novoAtendimentoAtivo.conteudos)) {
              novoAtendimentoAtivo.conteudos = [];
            }
            novoAtendimentoAtivo.conteudos.push(res.data);
            setAtendimentoAtivo(novoAtendimentoAtivo);
            setAtendimentoInCall(novoAtendimentoAtivo);
          }).catch(err => {
            console.error(err)
          })
        })
        setConnection(call);
        start();
      } else {
        handleLigacaoAtivaEncerrada();
      }
    } catch (e) {
      console.log('token', tokenTwilio)
      console.log(e)
      handleLigacaoAtivaEncerrada();
    }
  }

  // É DE SUMA IMPORTANCIA QUE ESTE MÉTODO SÓ SEJA ACIONADO CASO O TELEFONE TENHA QUE TOCAR PARA A MÁQUINA QUE ESTÁ EXECUTANDO ESTE CÓDIGO, EM OUTRAS PALAVRAS,
  // SÓ ACIONE ESTE CÓDIGO SE TIVER CERTEZA QUE O ATENDENTE DEVE RECEBER A LIGAÇÃO QUE CORRESPONDE A ESTE TOKEN
  // QUAISQUER QUE SEJAM AS VALIDAÇÕES, FAÇA POR FORA DESTE MÉTODO, OU REFATORE TODOS OS LOCAIS QUE O ACIONAM
  // Para Ligação Recebida
  const receiveCall = useCallback(async (connection_socket, idAtendimento, identificacaoTentativa = null, temCiclo = false) => {
    try {
      // Guarda o alvo do aceite antes de o telefone tocar; `answerCall` o consome: é a
      // identificação da tentativa que faz o `PUT /atender` disputar o atendimento
      // atomicamente com a expiração no backend, impedindo que um aceite atrasado tire a
      // ligação de quem já a tem. `temCiclo` distingue "fluxo sem ciclo" (transferência,
      // ligação ativa) de "ligação com ciclo ativo": numa oferta com ciclo e identificação
      // incompleta, o aceite não pode cair no caminho de aceite direto (defesa redundante com
      // a recusa 409 do backend).
      ofertaRecebida.current = { idAtendimento, identificacaoTentativa, temCiclo };
      let opcoes = getOpcoesClienteTwilio();
      const twilioDevice = clienteTwilioRespondeFactory(connection_socket, opcoes, idAtendimento, identificacaoTentativa);
      twilioRespondeClient.current = twilioDevice;
      registrarClient(twilioRespondeClient.current)
    } catch (error) {
      handleLigacaoPerdida();
    }
  }, [clienteTwilioRespondeFactory, twilioRespondeClient]);

  const getOpcoesClienteTwilio = () => {
    return {
      codecPreferences: ["opus", "pcmu"],
      logLevel: 5,
      appName: "Microfrontend Conecta",
      enableImprovedSignalingErrorPrecision: false,
      allowIncomingWhileBusy: false,
      maxCallSignalingTimeoutMs: 3000,
      sounds: {
        incoming: phoneRing
      }
    };
  }
  const handleCall = () => {
    const contatoOrigem = atendimentoAtivo?.contato_origem ?? null;
    caAPI.getTokenCcd(contatoOrigem).then(res => {
      setupCallClient(res.data)
    }).catch(err => {
      Swal.fire({
        titleText: "Erro",
        text: "Houve um problema ao buscar o token da chamada " + err,
        icon: 'error'
      });
    });
  }

  async function buscarEstadoAtualPermissaoMicrofone() {
    try {
      const { state } = await navigator.permissions.query({ name: 'microphone' })
      
      return state
    } catch (err) {
      console.error('Erro ao consultar permissão do microfone:', err)
      return 'denied'
    }
  }

  useEffect(() => {
    let ativo = true
    buscarEstadoAtualPermissaoMicrofone().then(state => {
      if(ativo) {
        setMicrofonePermitido(state)
      }
    })
    return () => ativo = false
  }, [])

  useEffect(() => {
    // Handler nomeado para o unbind ser direcionado: 'chamada-encerrada' também é ouvido pelo
    // dashboard, e o unbind sem callback removeria o ouvinte de lá junto com este.
    const aoEncerrarChamada = (data) => {
      if(data.CallSid === connection?.parameters?.CallSid){
        handleLigacaoAtivaEncerrada()
      }
    }
    channel.bind('chamada-encerrada', aoEncerrarChamada)
    return () => channel && channel?.unbind('chamada-encerrada', aoEncerrarChamada)
  }, [channel, connection])

  function exibirAlertaPermissaoNotificacaoPushNegada() {
    Swal.fire(
      'Permissão de Notificações Negada!', 
      'Você não receberá nenhum aviso de novas mensagens ou chamadas! Para ativar, vá nas configurações do seu navegador e permita as notificações.', 
      'warning'
    ) 
  }

  function solicitarPermissaoNotificacaoPush() {
    if("Notification" in window) {
      switch(Notification.permission) {
        case 'default':
          Notification.requestPermission().then(permissao => {
            if(permissao !== 'granted') {
              exibirAlertaPermissaoNotificacaoPushNegada()
            }
          })
          break
        case 'denied':
          exibirAlertaPermissaoNotificacaoPushNegada()
          break
      }
    } else {
      Swal.fire(
        'Notificações Desabilitadas!', 
        `O seu navegador não suporta as notificações do sistema, você não receberá nenhum aviso de novas mensagens ou chamadas! 
          Para receber as notificações troque de navegador.`, 
        'warning'
      ) 
    }
  }

  function solicitarPermissaoMicrofone() {
    // TODO: Validar permissão concedida apenas uma vez
    switch(microfonePermitido) {
      case 'denied':
        Swal.fire(
          'Permissão do Uso do Microfone Negada!', 
          `Você não pode receber ou realizar chamadas sem a permissão do microfone. 
            Por favor, ajuste as configurações do seu navegador clicando no ícone do microfone.`, 
          'warning'
        )
        return false
      case 'prompt':
        infoToast.fire({
          position: 'top-start',
          text: `Para receber e realizar chamadas, é necessário permitir o uso do microfone. Por favor, 
            ajuste as configurações do seu navegador clicando no ícone do microfone.`,
          timer: null,
          showConfirmButton: true,
          confirmButtonText: 'Entendi',
          toast: true,
          confirmButtonColor: 'var(--success)',
        }).then(() => {
          navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
              solicitarPermissaoNotificacaoPush()
            }).catch((error) => {
              errorToast.fire({ 
                text: `Você não conseguirá receber ou realizar chamadas sem a permissão do microfone. 
                  Por favor, ajuste as configurações do seu navegador clicando no ícone do microfone.`,
                timer: 8000,
              }).then(() => solicitarPermissaoNotificacaoPush())
              if (error.name === 'NotAllowedError') {
                console.error('Permissão negada pelo usuário.');
              } else if (error.name === 'NotFoundError') {
                console.error('Nenhum dispositivo de áudio foi encontrado.');
              } else if (error.name === 'OverconstrainedError') {
                console.error('As restrições solicitadas não puderam ser atendidas.');
              } else {
                console.error('Erro desconhecido:', error);
              }
            })
        })
        break
      default:
        if("Notification" in window && Notification.permission == 'default') {
          infoToast.fire({
            position: 'top-start',
            text: `Para receber notificações de novas mensagens e chamadas é necessário conceder permissão ao seu navegador.`,
            timer: null,
            showConfirmButton: true,
            confirmButtonText: 'Entendi',
            toast: true,
            confirmButtonColor: 'var(--success)',
          }).then(() => solicitarPermissaoNotificacaoPush())
        }
    }
  }

  function hangUp(rejeitar=false) {
    if(rejeitar && connection?.reject) {
      connection.reject()
      connection.disconnect()
      caAPI.atendimento.voip.encerrarConferencia(atendimentoAtivo.id).catch(error => {
        console.log(error)
        console.log(error.response)
      })
    }
    if(!rejeitar && connection?.ignore) {
      connection.ignore()
    }
    if (twilioRespondeClient.current) {
      twilioRespondeClient.current.disconnectAll();
    }
    if (twilioCallClient.current) {
      handleLigacaoAtivaEncerrada();
    }
    setInCallStatus(false);
  }

  function handleMuteCall() {
    if (connection) {
      const novoMutar = !isMuted;
      connection.mute(novoMutar)
      setIsMuted(connection.isMuted());
    }
  }

  function handleRejeitar() {
    if (connection) {
      connection.ignore();
    }
    if(twilioRespondeClient.current?.calls?.length) {
      const conexao = twilioRespondeClient.current.calls.shift();
      conexao.ignore()
      twilioRespondeClient.current.disconnectAll();
    }
    if (twilioCallClient.current && twilioCallClient.current.state == 'registered') {
      twilioCallClient.current.disconnectAll();
    }
  }

  function answerCall() {
    const oferta = ofertaRecebida.current;

    // Oferta de ligação com ciclo de tentativas ativo cuja identificação veio incompleta ou
    // ausente: NÃO se conecta o áudio direto. Conectar aqui registraria atendimento por fora
    // do ciclo — o backend recusa esse aceite (409) e, no caminho direto, o `/atender` nem
    // seria chamado. Trata-se como oferta perdida: descarta a conexão local, sem áudio.
    if (oferta && oferta.temCiclo && !oferta.identificacaoTentativa) {
      handleLigacaoPerdida();
      handleCloseModalIncoming();
      return;
    }

    // Fluxos sem ciclo de tentativas (transferência, ligação ativa): não há tentativa a
    // reivindicar atomicamente. Conecta o áudio direto.
    if (!oferta || !oferta.idAtendimento || !oferta.identificacaoTentativa) {
      connection.accept();
      setInCallStatus(true);
      start();
      // Transferência (oferta com idAtendimento): o aceite PRECISA confirmar o atendimento no
      // backend com PUT /{id}/atender. É esse endpoint que troca o atendente e dispara o evento
      // 'chamada-transferida', único sinal que encerra o loading do atendente de origem. Sem
      // essa chamada, o originador fica com o overlay preso para sempre. Como a transferência
      // não tem ciclo de tentativas, o payload leva só o atendente (sem identificação), e o
      // backend segue sem recusar. A resposta traz o atendimento, que promovemos a ativo para
      // o recebedor ver a ligação. A ligação ativa iniciada pelo próprio atendente não traz
      // idAtendimento na oferta e não cai aqui.
      if (oferta && oferta.idAtendimento) {
        caAPI.atendimento.atender({ atendente: caAPI.getLocalState('idUsuario') }, oferta.idAtendimento).then(res => {
          const atendimentoTransferido = Object.assign({}, res.data);
          setAtendimentoAtivo(atendimentoTransferido);
          setAtendimentoInCall(atendimentoTransferido);
        }).catch(err => {
          console.error('Falha ao confirmar o aceite da transferência', err);
        });
      }
      return;
    }

    // Ciclo de tentativas VoIP: confirma o atendimento no backend ANTES de conectar o áudio.
    // Só com o aceite confirmado (tentativa concluída por atendimento, atendente atualizado,
    // histórico registrado) a ligação é conectada a este atendente. Um aceite recusado —
    // tentativa já expirada, encerrada ou atendida por outro — não conecta o áudio.
    const atendenteId = Object.assign(
      { atendente: caAPI.getLocalState('idUsuario') },
      oferta.identificacaoTentativa
    );
    trackPromise(
      caAPI.atendimento.atender(atendenteId, oferta.idAtendimento).then(res => {
        connection.accept();
        const novoAtendimentoAtivo = Object.assign({}, res.data);
        setAtendimentoAtivo(novoAtendimentoAtivo);
        setAtendimentoInCall(novoAtendimentoAtivo);
        setInCallStatus(true);
        start();
      }).catch(err => {
        // 409: a tentativa já foi concluída (expirou, foi encerrada ou atendida por outro).
        // Não é erro do operador — a oferta aceita já não vale, então o áudio não é conectado:
        // a conexão local é descartada em vez de insistir num aceite recusado.
        if (err?.response?.status === 409) {
          handleLigacaoPerdida();
          handleCloseModalIncoming();
          return;
        }
        handleLigacaoPerdida();
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao atribuir o atendente  " + err,
          icon: 'error'
        });
      })
    );
  }

  const registrarContador = () => {
    pause();
    if (atendimentoAtivo) {
      caAPI.atendimento.getMessages(atendimentoAtivo.id, 1).then((res) => {
        if (res.data && res.data.conteudos) {
          const novoAtendimento = Object.assign({}, atendimentoAtivo);
          novoAtendimento.conteudos = res.data.conteudos
          setAtendimentoAtivo(novoAtendimento);
        }
      }).catch(error => console.log(error));
    }
    reset(null, false);

  };

  const handleFinalizarAtendimento = ()=>{
    const idAtendimento = atendimentoAtivo.id;
    const finalizado = { situacao: "4" };
    if(JSON.parse(caAPI.getLocalState('habilitaMarcadoresAposFinalizacao'))){
      setOpenModalAdicionarMarcadoresVoip(true);
    }else{
      Swal.fire({
        titleText: "Finalizar Atendimento",
        text: "Deseja finalizar o atendimento?",
        icon: 'question',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Sim, Finalizar',
        cancelButtonText: 'Não, manter',
        customClass: {
          confirmButton: 'btn btn-primary mr-3',
          cancelButton: 'btn btn-secondary mr-3',
        },
        buttonsStyling: false
      }).then(
        (result) => {
          if (result.value) {
            finalizarAtendimento(finalizado, idAtendimento);
          }
      })
    }
  }

  return (
    <VoipContext.Provider value={{
      receiveCall,
      inCallStatus,
      handleCall,
      hangUp,
      handleMuteCall,
      isMuted,
      setIsMuted,
      answerCall,
      handleRejeitar,
      connection,
      minutes,
      seconds,
      handleLigacaoPerdida,
      setupCallClient,
      handleLigacaoAtivaEncerrada,
      triggerCloseModalIncoming,
      twilioRespondeClient,
      adicionaChamadaPerdida,
      chamadasPerdidas,
      solicitarPermissaoMicrofone,
      buscarEstadoAtualPermissaoMicrofone,
      openModalAdicionarMarcadoresVoip, 
      setOpenModalAdicionarMarcadoresVoip,
      atendimentoInCall,
    }}>
      {children}
    </VoipContext.Provider>
  )
}
